import { css } from '@emotion/core';

export default () => ({
  sectionHeader: css`
    padding: 10px;
    border-bottom: 1px solid #ddd;
    border-top: 1px solid #ddd;
    font-weight: bold;
    width: 100%;
  `
});
